import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Container, Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink } from 'reactstrap'
import { Link, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import connect from 'react-redux/es/connect/connect'

import CTA from '../CTA-nav'
import { gaPv } from '../../modules/analytics/analytics'
import AuthModal from '../AuthModal/AuthModal'
import { openAuthModal } from '../../modules/auth/actions'
import firebase from '../../utils/firebase'

import '../../styles/nav.css'

const StyledNavbarBrand = styled(Link)`
  font-family: 'Work Sans', sans-serif;
  font-size: 24px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #916bff !important;
`

const StyledNavbar = styled(Navbar)`
  background-color: #ffffff !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
`

const VerifyNavbar = styled(Navbar)`
  background-color: #651fff !important;
  color: #fff;
  border: none !important;
  text-align: center !important;
  display: inherit !important;
  margin-top: 56px;
  padding: .2rem 1rem !important;

  @media (min-width: 673px) {
    margin-top: 63px;
  }

  @media (min-width: 768px) {
    margin-top: 69px;
  }
`

const StyledPhone = styled.span`
  color: #916bff;
`

const StyledNavLink = styled(NavLink)`
  font-size: 15px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #888888;
`

const StyledLink = styled(Link)`
  font-size: 15px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #888888;
`

const StyledResend = styled.span`
  text-decoration: underline;
  margin-left: .5rem;
  font-weight: 600;

  &:hover {
    cursor: pointer;
  }
`

const StyledEmailSent = styled.span`
  margin-left: .5rem;
  font-weight: 600;
`

class NavBar extends Component {
  state = {
    isOpen: false,
    emailSent: false
  }

  static propTypes = {
    authUser: PropTypes.object,
    openAuthModal: PropTypes.func.isRequired
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  close = () => {
    if (this.state.isOpen) {
      this.setState({
        isOpen: false
      })
    }
  }

  openIntercom = () => {
    this.close()
    gaPv('/contact')
    window.Intercom('showNewMessage', 'Hello!')
  }

  sendVerification = () => {
    const user = firebase.auth().currentUser

    if (user) {
      user.sendEmailVerification()
      this.setState({ emailSent: true })

      setTimeout(() => {
        this.setState({ emailSent: false })
      }, 5000)
    }
  }

  render () {
    const {
      authUser,
      openAuthModal
    } = this.props

    return (
      <Fragment>
        <StyledNavbar light expand='md' className='fixed-top' >
          <AuthModal />

          <Container fluid>
            <StyledNavbarBrand className='navbar-brand' to='/'>Homevest</StyledNavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className='ml-auto' navbar>
                <NavItem>
                  <StyledLink className='nav-link' to='/story' onClick={this.close}>Our Story</StyledLink>
                </NavItem>
                <NavItem>
                  <StyledLink className='nav-link' to='/faq' onClick={this.close}>FAQ</StyledLink>
                </NavItem>
                {!authUser && (
                  <Fragment>
                    <NavItem>
                      <StyledNavLink onClick={this.openIntercom}>Contact</StyledNavLink>
                    </NavItem>
                    <NavItem>
                      <StyledNavLink className='nav-link' onClick={openAuthModal}>Sign In</StyledNavLink>
                    </NavItem>
                    <NavItem>
                      <StyledNavLink href='tel:6468383165'>
                        <StyledPhone>(646) 838-3165</StyledPhone>
                      </StyledNavLink>
                    </NavItem>
                  </Fragment>
                )}
                {authUser && (
                  <Fragment>
                    <NavItem style={{ marginRight: '0.5rem' }}>
                      <StyledLink className='nav-link' to='/account' onClick={this.close}>
                        Account
                      </StyledLink>
                    </NavItem>
                  </Fragment>
                )}

                <NavItem>
                  <CTA />
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </StyledNavbar>

        {authUser && !firebase.auth().currentUser.emailVerified && (
          <VerifyNavbar className='fixed-top'>
            Please verify your email. {this.state.emailSent && (<StyledEmailSent>Email Sent!</StyledEmailSent>)} <StyledResend onClick={this.sendVerification}>Resend verification</StyledResend>
          </VerifyNavbar>
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  authUser: state.auth.authUser
})

const mapDispatchToProps = {
  openAuthModal
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar))
